import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
/** 기본 스켈레톤 박스 */ export const Skeleton = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("animate-pulse bg-gray-50 rounded-md", className)
    });
};
/** 텍스트 스켈레톤 */ export const SkeletonText = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx(Skeleton, {
        className: cn("h-4 w-full", className)
    });
};
/** 이미지/썸네일 스켈레톤 */ export const SkeletonImage = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx(Skeleton, {
        className: cn("aspect-[4/3] w-full", className)
    });
};
/** 버튼 스켈레톤 */ export const SkeletonButton = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx(Skeleton, {
        className: cn("h-10 w-24 rounded-full", className)
    });
};
// ===== 섹션별 스켈레톤 =====
/** PR Image (FreePromotion) 섹션 스켈레톤 */ export const PrImageSectionSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs("section", {
        className: "flex flex-col gap-5 w-full max-sm:gap-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 max-lg:px-8 max-sm:px-5",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-8 w-64 max-sm:h-6 max-sm:w-48"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-5 w-40 max-sm:h-4 max-sm:w-32"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex gap-5 overflow-hidden max-lg:px-8 max-sm:px-5 max-sm:gap-3",
                children: Array.from({
                    length: 4
                }).map((_, i)=>/*#__PURE__*/ _jsx(Skeleton, {
                        className: "flex-shrink-0 w-[280px] h-[160px] rounded-lg max-sm:w-[200px] max-sm:h-[120px]"
                    }, i))
            })
        ]
    });
};
/** Brand Section 스켈레톤 */ export const BrandSectionSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs("section", {
        className: "flex flex-col gap-6 w-full my-10",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 max-lg:px-8 max-sm:px-5",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-8 w-72 max-sm:h-6 max-sm:w-56"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-5 w-48 max-sm:h-4 max-sm:w-36"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex gap-5 overflow-hidden max-lg:px-8 max-sm:px-5 max-sm:gap-3",
                children: Array.from({
                    length: 5
                }).map((_, i)=>/*#__PURE__*/ _jsxs("div", {
                        className: "flex-shrink-0 w-[220px] flex flex-col gap-3 max-sm:w-[160px]",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "aspect-[16/10] w-full rounded-lg"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-5 w-3/4"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-6 w-12 rounded-full"
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-6 w-16 rounded-full"
                                    })
                                ]
                            })
                        ]
                    }, i))
            })
        ]
    });
};
/** Product Section (Curation) 스켈레톤 */ export const ProductSectionSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs("section", {
        className: "flex flex-col gap-6 w-full my-10",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 max-lg:px-8 max-sm:px-5",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-8 w-80 max-sm:h-6 max-sm:w-60"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-5 w-40 max-sm:h-4 max-sm:w-32"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex gap-5 overflow-hidden max-lg:px-8 max-sm:px-5 max-sm:gap-3",
                children: Array.from({
                    length: 5
                }).map((_, i)=>/*#__PURE__*/ _jsxs("div", {
                        className: "flex-shrink-0 w-[200px] flex flex-col gap-3 max-sm:w-[150px]",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "aspect-[3/4] w-full rounded-lg"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-3/4"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-5 w-1/2"
                            })
                        ]
                    }, i))
            })
        ]
    });
};
/** IP Select 섹션 스켈레톤 */ export const IpSelectSectionSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-3",
                        children: /*#__PURE__*/ _jsx(Skeleton, {
                            className: "h-10 w-md"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-3",
                        children: Array.from({
                            length: 4
                        }).map((_, i)=>/*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-9 w-20 rounded-md"
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                className: "h-[100px] w-full rounded-xl max-sm:h-[150px]"
            })
        ]
    });
};
/** Billing Plan 섹션 스켈레톤 */ export const BillingPlanSectionSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full flex flex-col gap-5 py-10 max-sm:py-6",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 max-lg:px-8 max-sm:px-5",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-8 w-64 max-sm:h-6 max-sm:w-48"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-5 w-96 max-sm:h-4 max-sm:w-64"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex gap-2 max-md:px-8 max-sm:px-5",
                children: Array.from({
                    length: 3
                }).map((_, i)=>/*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-10 w-20 rounded-full"
                    }, i))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-5 overflow-hidden max-sm:px-5 sm:px-8 md:grid md:grid-cols-12 md:px-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "md:col-span-6",
                        children: /*#__PURE__*/ _jsx(Skeleton, {
                            className: "h-[300px] w-[400px] rounded-xl md:w-full max-sm:h-[220px] max-sm:w-[300px]"
                        })
                    }),
                    Array.from({
                        length: 2
                    }).map((_, i)=>/*#__PURE__*/ _jsx("div", {
                            className: "md:col-span-3",
                            children: /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-[300px] w-[200px] rounded-xl md:w-full max-sm:h-[220px] max-sm:w-[150px]"
                            })
                        }, i))
                ]
            })
        ]
    });
};
/** Step 섹션 스켈레톤 */ export const StepSectionSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full flex flex-col gap-5 max-sm:gap-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 max-lg:px-8 max-sm:px-5",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-8 w-72 max-sm:h-6 max-sm:w-56"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-5 w-64 max-sm:h-4 max-sm:w-48"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "max-lg:px-8 max-sm:px-5",
                children: /*#__PURE__*/ _jsx(Skeleton, {
                    className: "h-14 w-full rounded-lg max-sm:h-12"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex gap-5 overflow-hidden max-lg:px-8 max-sm:px-5 max-sm:gap-3",
                children: Array.from({
                    length: 5
                }).map((_, i)=>/*#__PURE__*/ _jsx(Skeleton, {
                        className: "flex-shrink-0 w-[180px] h-[200px] rounded-xl max-sm:w-[140px] max-sm:h-[160px]"
                    }, i))
            })
        ]
    });
};
/** Slogan 섹션 스켈레톤 */ export const SloganSectionSkeleton = ()=>{
    return /*#__PURE__*/ _jsx(Skeleton, {
        className: "w-full h-[120px] rounded-lg max-sm:h-[80px]"
    });
};
/** 메인 배너 스켈레톤 */ export const MainBannerSkeleton = ()=>{
    return /*#__PURE__*/ _jsx(Skeleton, {
        className: "w-full h-[300px] rounded-lg max-sm:h-[200px]"
    });
};
/** 퀵메뉴 스켈레톤 */ export const QuickMenuSkeleton = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "flex justify-center gap-4 overflow-hidden px-8 pb-8 max-sm:px-5 max-sm:gap-3",
        children: Array.from({
            length: 8
        }).map((_, i)=>/*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center gap-2 flex-shrink-0",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "w-16 h-16 rounded-md max-sm:w-12 max-sm:h-12"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-4 w-14 max-sm:h-3 max-sm:w-10"
                    })
                ]
            }, i))
    });
};
/** Home 전체 스켈레톤 */ export const HomeSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full flex flex-col gap-14 max-lg:gap-12 max-sm:gap-8",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-col gap-10 bg-gray-50",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "max-w-[1200px] mx-auto w-full flex flex-col gap-8 py-8 max-sm:gap-5",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "max-lg:px-8 max-sm:px-5",
                            children: /*#__PURE__*/ _jsx(Skeleton, {
                                className: "w-full h-[300px] rounded-lg max-sm:h-[200px]"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex justify-center gap-4 overflow-hidden px-8 max-sm:px-5 max-sm:gap-3",
                            children: Array.from({
                                length: 8
                            }).map((_, i)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-col items-center gap-2 flex-shrink-0",
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton, {
                                            className: "w-16 h-16 rounded-md max-sm:w-12 max-sm:h-12"
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton, {
                                            className: "h-4 w-14 max-sm:h-3 max-sm:w-10"
                                        })
                                    ]
                                }, i))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "max-w-[1200px] mx-auto w-full flex flex-col gap-10 max-sm:gap-5",
                children: [
                    /*#__PURE__*/ _jsx(PrImageSectionSkeleton, {}),
                    /*#__PURE__*/ _jsx(BrandSectionSkeleton, {}),
                    /*#__PURE__*/ _jsx(ProductSectionSkeleton, {})
                ]
            })
        ]
    });
};
